import useSWR from 'swr'
import { Search } from '@graphql/queries'
import request from 'graphql-request'
import { useEffect } from 'react'
import { trackSiteSearch } from '@helpers/matomo'

const fetcher = async (query, term, type) => {
  if (!term || term?.length < 3) return []

  return request('/graphql', query, { term, type })
}

const useSearch = (term, type) => {
  const { data, mutate, error, isValidating } = useSWR([Search, term, type], fetcher)

  useEffect(() => {
    if (!isValidating && data?.search && term?.length > 2) {
      trackSiteSearch(term, type, data.search.length)
    }
  }, [data?.search, isValidating])

  return {
    searchResults: data?.search,
    error,
    mutate,
    isValidating,
    isLoading: !error && !data,
  }
}

export { useSearch }
